const mainContent = {
  title: "Z-KLEAN",
  imageCredits: (
    <div>
      Foto de:
      <a
        href="https://unsplash.com/es/@brookelark?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
        target="_blank"
        rel="noopener noreferrer"
      >
        Brooke Lark
      </a>
      , en:
      <a
        href="https://unsplash.com/es/fotos/variedad-de-frutas-en-rodajas-08bOYnH_r_E?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
        target="_blank"
        rel="noopener noreferrer"
      >
        Unsplash
      </a>
    </div>
  ),
  subtitle: "Producto bionanotecnológico - línea hogar",
  paragraphOne:
    "Un potente biocida natural, este producto de desinfección está diseñado para actuar eficazmente contra los principales microorganismos, eliminando bacterias como E. coli y Salmonella spp. Es ideal para mantener la seguridad alimentaria en el hogar y en entornos profesionales, con aplicaciones versátiles en diversas áreas.",
}

const applicationFruits = {
  title: "Frutas y Verduras",
  description:
    "Desinfecta frutas y verduras, prolonga su frescura y disfruta ensaladas seguras con alimentos sin cocción.",
  imagePath: "atbionano/z-klean-application-fruits.jpg",
  imageCredits: (
    <div class="flex w-full justify-end pr-4">
      Foto de:
      <a
        href="https://unsplash.com/es/@lotusdnp?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
        target="_blank"
        rel="noopener noreferrer"
      >
        Lotus Design N Print
      </a>{" "}
      , en:{" "}
      <a
        href="https://unsplash.com/es/fotos/mueble-de-cocina-de-madera-blanca-con-lampara-colgante-negra-KiUg-4xmTwo?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
        target="_blank"
        rel="noopener noreferrer"
      >
        Unsplash
      </a>
    </div>
  ),
}

const applicationSurface = {
  title: "Superficies y utensilios de cocina",
  description:
    "Protege cocinas y alimentos eliminando microorganismos potencialmente.",
  imagePath: "atbionano/z-klean-application-table-surface",
  imageCredits: (
    <div class="flex w-full justify-end pr-4">
      Foto de:{" "}
      <a
        href="https://unsplash.com/es/@dirtjoy?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
        target="_blank"
        rel="noopener noreferrer"
      >
        Zoe Schaeffer
      </a>{" "}
      , en{": "}
      <a
        href="https://unsplash.com/es/fotos/tomates-amarillos-y-rojos-en-una-caja-de-plastico-verde-hmoDcZnB7uw?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
        target="_blank"
        rel="noopener noreferrer"
      >
        Unsplash
      </a>
    </div>
  ),
}

export const ZkleanMessages = {
  mainContent,
  applicationFruits,
  applicationSurface,
}
